import { Component, Renderer2 } from "@angular/core";
import { Guid } from "../../../../common/helpers/guidHelper";
import { UploadService } from "../../../../services/uploadService";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'amazon-product-export',
    templateUrl: 'amazon-product-export.component.html',
    moduleId: module.id.toString()
})
export class AmazonProductExportComponent {
    public constructor(private route: ActivatedRoute, private uploadService: UploadService, private renderer: Renderer2) {

    }

    public ngOnInit(): void {
        this.route.params.subscribe(param => {
            let sellerId = param['sellerId'];
            let storeId = param['storeId'];

            this.uploadService.downloadFile(null, `amazon/seller/${sellerId}/store/${storeId}/export`,
                [],
                `amazon_products.csv`).then(x => {
                setTimeout(_ => {
                    window.close();
                }, 1000);
            });
        })
    }

    public ngAfterViewInit(): void {
        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/amazon-management/store/amazon-product-export.component.ts